import Button from "@/components/core/Button/Button"
import Modal from "@/components/core/Modal/Modal"
import styles from "./index.module.scss"
export const QuantityModal = ({ showModal, setShowModal, modalText }) => {
  return (
    <div className={styles.quantityModal}>
      <Modal showModal={showModal} onModalClose={() => setShowModal(false)}>
        <div className="quantity-modal">
          <div className="quantity-modal__header">
            {`The number of installation services may have changed to match the updated product quantity.`}{" "}
          </div>
          <Button
            customClass="quantity-modal__button"
            label={"Continue"}
            flexible
            type="black"
            onClick={() => setShowModal(false)}
            role="button"
          />
        </div>
      </Modal>
    </div>
  )
}
